import React, { Component, Fragment } from 'react'
import { ProtectedOperationsService } from './services';
import { HttpResponse } from '../../../core';
import { NavLink } from "react-router-dom";
import { ProtectedOperationsTabs } from './ProtectedOperationsTabs'
import { DropdownItemModel } from '../../../shared/models';
import { ButtonType } from '../../../shared/enums/button.enum';
import { ShowSuccessMessage, HandleNotFoundResponse } from '../../../shared/helpers';
import { NotFoundResponseArea } from '../../../shared/enums';
import { ProtectedOperationsDeleteModel, ProtectedOperationsDeleteResponseModel } from './models';

interface IState {
    result?: ProtectedOperationsDeleteModel;
    deleteResult?: ProtectedOperationsDeleteResponseModel;
    isDoubleleClick?: boolean;
}
export class DeleteProtectedOperations extends Component<any, IState> {
    private service: ProtectedOperationsService;
    constructor(props) {
        super(props);
        this.state = this.initialState;
        this.service = new ProtectedOperationsService();
        this.deleteRecord = this.deleteRecord.bind(this);
    }

    initialState: Partial<IState> = {
        result: {
            id: 0,
            operation:"",
            record_type:"",
            staq_notes:""           
        },
        deleteResult: { isdeleted: false },
        isDoubleleClick: false
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        this.service.getLinkedResourcesById(this.props.match.params.id)
            .then((res: HttpResponse<ProtectedOperationsDeleteModel>) => {
                if (res && res.result) {
                    this.setState({
                        result: res.result
                    });
                }
            })
            .catch(ex => {
                HandleNotFoundResponse(ex,NotFoundResponseArea.ProtectedOperation,this.props) 
            });
    }

    deleteRecord() {
        if (!this.state.isDoubleleClick) {
            this.setState({ isDoubleleClick: true })
            this.service.deleteRecordById(this.props.match.params.id)
                .then((res: HttpResponse<ProtectedOperationsDeleteResponseModel>) => {
                    if (res && res.result) {
                      
                        this.setState({
                            deleteResult: res.result
                        }, () => {
                            if (this.state.deleteResult?.isdeleted) {
                                ShowSuccessMessage("Protected Operation Successfully deleted.");
                                this.props.history.push('/protected-operation/list');
                            }
                        });
                    }
                });
        }
    }

    render() {
        return (
            <Fragment>
                {/* {this.state.result?.scheduled_reports.value == this.props.match.params.id && <div> */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5>Delete  Protected Operation '{this.state.result?.record_type}:&nbsp;{this.state.result?.operation}'</h5>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <ProtectedOperationsTabs id={this.props.match.params.id} url="/protected-operation/delete/" />
                                <div className="alert font-weight-bold  alert-light"> <i className="fas fa-exclamation-circle text1"></i> Are you sure you want to delete this protected operation <strong>“{this.state.result?.record_type}:&nbsp;{this.state.result?.operation}”</strong> ?</div>
                                <p className="mt-4 text-danger"><i className="fas fa-exclamation-triangle text1"></i> The following related items may be deleted or orphaned:</p>
                                <div className="row">
                                    <div className="col">
                                        <div className="card card-primary shadow-sm">
                                            <div className="card-header">
                                                <h4>Protected Operation</h4>
                                            </div>
                                            <div className="card-body">
                                                <NavLink className="badge badge-light text-link" to={"/protected-operation/detail/" + this.state.result?.id}>{this.state.result?.record_type}:&nbsp;{this.state.result?.operation} </NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="mx-auto">
                                <button className="btn btn-lg btn-danger" disabled={this.state.isDoubleleClick} onClick={this.deleteRecord}> {ButtonType.Delete}</button>
                                <NavLink type="button" className="btn btn-lg btn-default ml-3" to="/protected-operation/list">{ButtonType.Cancel}</NavLink>
                            </div>
                        </div>
                    </div>
                </div>
                {/* </div>} */}
            </Fragment>
        )
    }
}
